import { api, telecontrol } from "@service";

export const getOS = async (value: string, requestValue: string) => {
  const response = await api.get(`/os/sforce/${requestValue}/${value}`, {
    headers: {
      "Access-Application-Key": telecontrol,
      "Access-Env": "PRODUCTION",
    },
  });

  return response;
};

export const getInteractionsByCalledId = async (calledId: string) => {
  const response = await api.get(`api-helpdesk/helpdesk/helpdesk/${calledId}`, {
    headers: {
      "Access-Application-Key": telecontrol,
      "Access-Env": "PRODUCTION",
    },
  });
  return response;
};
